module.exports = __webpack_public_path__ + "static/silne-zazemi-535f8c999f8cc7b0c59391d64220a62e.jpg";